import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useField } from 'formik'
import { SelectedImage } from 'types'
import { MobileAddFromAnotherSourceButton } from './MobileAddFromAnotherSourceButton'
import { DesktopAddFromAnotherSourceButton } from './DesktopAddFromAnotherSourceButton'
import { ResponsiveAddFromAnotherSourceButtonProps } from 'components/Wizards/SelectImages/Types'
import { useImages } from 'components/Wizards/SelectImages/ImagesProvider'

export const ResponsiveAddFromAnotherSourceButton = ({ onAdd }: ResponsiveAddFromAnotherSourceButtonProps) => {
  const { isMobile } = useResponsiveDesign()
  const { setImages } = useImages()
  const [{ value: selectedImages }, , { setValue: setSelectedImages }] = useField<string[]>('selected_images')

  const handleAdd = async (pickerImages: SelectedImage[]) => {
    setImages((images) => [...images, ...pickerImages.map((image) => image.url)])
    const newImages = [...selectedImages, ...pickerImages.map((image) => image.url)]
    await setSelectedImages(newImages)
    onAdd(pickerImages.length)
  }

  return isMobile ? (
    <MobileAddFromAnotherSourceButton onAdd={handleAdd} />
  ) : (
    <DesktopAddFromAnotherSourceButton onAdd={handleAdd} />
  )
}
